import MouseFollower from "mouse-follower";
import gsap from "gsap";

MouseFollower.registerGSAP(gsap);

const pointerSelectors = [
    'a', 'button', '[data-button]',
    '.fslightbox-slide-btn-container',
    '.fslightbox-toolbar-button',
    '.cookiemate-widget a',
    '.cookiemate-widget label',
    '.cookiemate-widget .cookiemate-cookies-button',
].join(',');

if (window.matchMedia('(pointer:fine)').matches) {
    const cursor = new MouseFollower({
        container: document.documentElement,
        stateDetection: {
            '-pointer': pointerSelectors,
        },
    });
}